import React from 'react'
import PhysicalCardsTable from 'src/components/DataGrid/tables/PhysicalCardsTable/PhysicalCardsTable'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletPhysicalCardsRouteProps } from 'src/navigation/routeProps'

const MyWalletPhysicalCardsAppRoute: AppRoute = {
  id: AppLocation.MyWalletPhysicalCards,
  routeProps: myWalletPhysicalCardsRouteProps,
  component: <PhysicalCardsTable />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletPhysicalCardsAppRoute
